<template lang="pug">
b-modal#updateLivechat(
  ref="updateLivechat"
  :title="titleName"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.chat_provider')" :disabled="cpOptionList.length == 1 || item != null").mb-0
      b-form-select(
        :dirty="$v.chat_provider.$dirty"
        :error="$v.chat_provider.$error"
        v-model.trim.lazy="$v.chat_provider.$model"
        :disabled="loading"
        size="sm"
      )
        option(value="" disabled) {{ $t('message.select_option') }}
        option(v-for="item in cpOptionList" :value="item") {{ item }}
      ValidateResult(:value="$v.chat_provider" :name="$t('ui.chat_provider')")
    template(v-if="chat_provider != null && chat_provider != '' && chat_provider != 'ZENO'")
      .alert.alert-warning.p-1.mb-2.w-100 *{{ $t("message.banner_size_tooltips", { size: '126px x 126px' }) }}
      b-form-group.w-100(:label="$t('ui.image')").mb-0
        b-form-file(
          v-model="img"
          ref="file"
          accept="image/jpeg, image/png, image/jpg"
          @change="onSelect"
          v-if="imgSrc == null"
        )
        ValidateResult(:value="$v.img" :name="$t('ui.image')")
        SubmitButton(
          :loading="loading"
          icon="fa fa-times"
          :text="$t('ui.remove')"
          type="button"
          @click="removeImage()"
          variant="danger"
          size="sm"
          v-if="imgSrc != null"
          )
        template(v-if="imgSrc != null")
          br
          b-img.w-50.h-50(:src="imgSrc")
    template(v-if="chat_provider == 'LIVECHATINC'")
      b-form-group.mb-0
        label {{ $t('ui.chat_id') }}
        a(href='javascript:void(0)' @click="togglePopup")
          i.far.fa-question-circle.text-info.ml-2
        .popup-image(v-if="showPopup")
          i.btn.btn-danger.fas.fa-times.close-icon(@click='showPopup = false')
          img(src="/assets/img/livechatguide.jpeg" alt='Popup Image' )
        DebounceInput(
          size="sm"
          ref="chat_id"
          required
          type="text"
          :dirty="$v.chat_id.$dirty"
          :error="$v.chat_id.$error"
          v-model.trim.lazy="$v.chat_id.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.chat_id" :name="$t('ui.chat_id')")

    template(v-else-if="['TAWK','ZENO'].includes(chat_provider)")
      b-form-group(:label="revisedCredentialLabel()").mb-0
        DebounceInput(
          size="sm"
          ref="credential_1"
          type="text"
          :dirty="$v.credential_1.$dirty"
          :error="$v.credential_1.$error"
          v-model.trim.lazy="$v.credential_1.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.credential_1" :name="revisedCredentialLabel()")
      template(v-if="['TAWK'].includes(chat_provider)")
        b-form-group(:label="$t('ui.widget_id')").mb-2
          DebounceInput(
            size="sm"
            ref="credential_2"
            type="text"
            :dirty="$v.credential_2.$dirty"
            :error="$v.credential_2.$error"
            v-model.trim.lazy="$v.credential_2.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.credential_2" :name="$t('ui.widget_id')")

    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)

</template>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const fileSizeValidation = (value) =>  {
  if (!value) {
    return true;
  }
  let file = value;
  return (file.size < 1048576);
};
const base64Encode = data =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    existChatProvider: {
      type: [String, Array],
      default: null
    },
    cpList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      chat_id: null,
      image_id: null,
      chat_provider: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      titleName: this.$t('ui.combine.update_livechat'),
      showPopup: false,
      img_url: "",
      img: null,
      imageName: "",
      imgSrc: null,
      credential_1: "",
      credential_2: "",
      modalType: "update",
      cpOptionList: []
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    }
  },
  validations: {
    chat_id: {
      required: requiredIf(function() {
        return ['LIVECHATINC'].includes(this.chat_provider)
      })
    },
    chat_provider: {
      required
    },
    img: {
      fileSizeValidation
    },
    credential_1: {
      required: requiredIf(function() {
        return ['TAWK','ZENO'].includes(this.chat_provider)
      })
    },
    credential_2: {
      required: requiredIf(function() {
        return ['TAWK'].includes(this.chat_provider)
      })
    }
  },
  watch: {
    img(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.imgSrc = value;
            })
            .catch(() => {
              this.imgSrc = null;
            });
        } else {
          this.imgSrc = null;
        }
      }
    }
  },
  methods: {
    revisedCredentialLabel() {
      var label = this.$t('ui.property_id')
      switch(this.chat_provider) {
        case 'TAWK':
          label = this.$t('ui.property_id');
          break;
        case 'ZENO':
          label = this.$t('ui.platform');
          break;
      }

      return label
    },
    togglePopup() {
      this.showPopup = !this.showPopup;
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    removeImage() {
      this.img = null;
      this.img_url = "";
      this.imageName = "";
      this.imgSrc = null;
    },
    onSelect(evt) {
      if(evt.target.files.length > 0){
        this.imageName = evt.target.files[0].name;
      }else{
        return
      }
    },
    async uploadImage() {
      if (this.imageName == "") return;

      const formData = new FormData();
      formData.append("file", this.img);
      this.loading = true;
      try {
        await this.$http
          .post(config.uploadImageUrl, formData)
          .then(function(response) {
            this.loading = false;
            if (response.data.file.filename) {
              this.img_url = response.data.file.filename;
            }
            // this.proceed();
          });
      } catch (err) {
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
      }
    },
    async confirmSubmit() {
      const p1 = this.uploadImage();
      const someResult = await p1;

      this.proceed();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if(!['ZENO'].includes(this.chat_provider))
          this.confirmSubmit();
        else
          this.proceed();
      }
    },
    proceed: function() {
      let url = ""
      if(this.item == null) {
        url = config.accountChatAddUrl();
      } else {
        url = config.accountChatUpdateUrl();
      }

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        chat_id: this.chat_id,
        chat_provider: this.chat_provider,
        image_id: this.img_url
      };

      if(['TAWK','ZENO'].includes(this.chat_provider)) {
        json.credential_1 = this.credential_1
      }

      if(['TAWK'].includes(this.chat_provider)) {
        json.credential_2 = this.credential_2
      }

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked", this.modalType);
                this.$refs.updateLivechat.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", this.modalType + "_livechat", this.feedback.status);
                this.$refs.updateLivechat.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.chat_id = null;
      this.image_id = null;
      this.img_url = "";
      this.imageName = "";
      this.chat_provider = "";
      this.credential_1 = "";
      this.credential_2 = "";
      this.showPopup = false;
      this.modalType = "update"
      this.cpOptionList = []
    },
    shown: function() {
      this.$v.$reset();
      if(this.item != null) {
        this.titleName = this.$t('ui.combine.update_livechat')
        this.$nextTick(() => {
          this.chat_id = this.item.chat_id;
          // this.image_id = this.item.image_id;
          this.chat_provider = this.item.chat_provider;
          this.imgSrc = this.item.image_id != null ? config.viewImageUrl + this.item.image_id : null;
          this.img_url = this.item.image_id;
          this.imageName = "";
          this.credential_1 = this.item.credential_1
          this.credential_2 = this.item.credential_2
          this.cpOptionList = this.cpList
        });
      } else {
        this.modalType = 'add'
        this.titleName = this.$t('ui.combine.add_livechat')
        this.chat_provider = ''
        this.imgSrc = null
        const setB = new Set(this.existChatProvider)
        this.cpOptionList = this.cpList.filter(item => !setB.has(item))
        if(this.cpOptionList.length == 1) {
          this.chat_provider = this.cpOptionList[0]
        }
      }
    }
  }
};
</script>

<style scoped>
.popup-image {
  position: absolute;
  top: -100px;
  left: 0;
  background: white;
  border: 1px solid #ccc;
  border-radius: 21px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  /* padding: 10px; */
  z-index: 1000;
}

.popup-image img {
  max-width: 800px;
  height: auto;
}
</style>